import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { MessageCircle, X, ExternalLink } from "lucide-react";
import { SupportChat } from "@/components/SupportChat";

export default function SupportWidget() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Hidden on the marketing landing page (it has its own sticky mobile CTA) and on auth pages.
  const hiddenOn = ["/", "/login", "/register"];
  if (hiddenOn.includes(location.pathname)) return null;

  return (
    <>
      {open && (
        <div
          className="fixed bottom-24 right-4 z-[60] flex h-[70vh] max-h-[560px] w-[min(92vw,380px)] flex-col border border-black/10 bg-[#F9FAFB] shadow-2xl sm:right-6"
          data-testid="support-widget-panel"
        >
          <div className="flex items-center justify-between bg-brand-dark px-4 py-3 text-white">
            <div className="flex items-center gap-2">
              <MessageCircle size={16} />
              <span className="font-display text-base">Support</span>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/support" data-testid="support-open-page" className="text-white/70 transition-colors hover:text-white" title="Open full page" aria-label="Open support page">
                <ExternalLink size={15} />
              </Link>
              <button onClick={() => setOpen(false)} data-testid="support-widget-close" className="text-white/70 transition-colors hover:text-white" aria-label="Close support">
                <X size={17} />
              </button>
            </div>
          </div>
          <div className="flex-1 overflow-hidden">
            <SupportChat compact />
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="support-widget-toggle"
        aria-label={open ? "Close support" : "Open support"}
        className="fixed bottom-5 right-4 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-klein text-white shadow-xl transition-transform hover:scale-105 hover:bg-brand-dark sm:right-6"
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>
    </>
  );
}
